<template>
  <div class="popup-background">
    <div class="popup-window">
      <div class="popup-header">
        <h1 class="popup-title">{{ capitalize($t('exportSelection.title')) }}</h1>
      </div>
      <div v-if="validationError" class="form-row">
        <div class="validationerror-block">{{ validationError }}</div>
      </div>
      <div class="popup-form">
        <div class="form-row">
          {{ capitalize($t(amount === 1 ? 'exportSelection.descriptionSingle' : 'exportSelection.description', { amount: amount })) }}:
        </div>
      </div>
      <div class="form-row">
        <button @click="send('csv')" class="input-button input-button-primary" :disabled="this.sending">CSV</button>
        <button @click="send('pdf')" class="input-button input-button-primary" :disabled="this.sending">PDF</button>
      </div>
      <div class="popup-close" @click="close">&#10006;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-selection-export',
  emits: ['close'],
  computed: {
    amount () {
      return this.data ? this.data.length : 0
    }
  },
  data: () => ({
    data: null,
    validationError: null,
    sending: false
  }),
  methods: {
    reset () {
      this.validationError = null
      this.sending = false
      this.data = null
    },
    load (exportData = null) {
      this.reset()

      if (!exportData) return

      this.data = Array.isArray(exportData) ? exportData : [exportData]
    },
    async send (format) {
      if (this.sending || !this.data) return

      this.validationError = null
      this.sending = true

      const storeData = {
        items: this.data,
        name: `${this.$t('exportSelection.fileName')}_${new Date().toISOString().slice(0, 10)}`
      }

      const action = format === 'pdf' ? 'searchStore/fetchSelectionExportPDF' : 'searchStore/fetchSelectionExportCSV'
      const result = await this.$store.dispatch(action, storeData)

      if (!result || result.error) {
        this.sending = false
        this.validationError = result?.error
        return false
      }

      this.sending = false
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-row {
    margin: 10px 0;

    .input-button + .input-button {
      margin-left: 10px;
    }
  }

  .validationerror-block {
    padding: 10px;
    border: 1px solid red;
    border-radius: 4px;
    background-color: rgba(255, 0, 0, 0.1);
  }
</style>
